import React, {useContext, useEffect, useState} from 'react';
import {AppContext} from '../../context/app/appContext';
// import _ from 'lodash'
import {Button, Dimmer, Modal, Loader, Table, Checkbox, Icon, Search} from 'semantic-ui-react';
import axios from 'axios';
import {TeamDetailsTable} from './TeamDetailsTable';
import { EmployeeDetails } from '../Employees/EmployeeDetails';
import {useHistory, Switch, Route, useParams} from 'react-router-dom';

export const TeamDetails = (props) => {
    
    // const [team, setTeam] = useState(props.teamData)
    const [team, setTeam] = useState(null)
    const [employees, setEmployees] = useState(null)
    const [teamSize, setTeamSize] = useState(0)
    const [perkCount, setPerkCount] = useState(0)
    const [expenseCount, setExpenseCount] = useState(0)
    const [created, setCreated] = useState('')
    const [selectEmployee, setSelectEmployee] = useState(false)
    const [selectedEmployee, setSelectedEmployee] = useState({})
    const [thisPage, setThisPage] = useState('none')
    const [trigger, setTrigger] = useState(false)

    const appContext = useContext(AppContext);
    const {id} = useParams()
    // const id = "5f47ccdda720667369869210"
    const history = useHistory()

    useEffect(() => {
        (async function loadTeams() {
            if(!appContext.teams.length){
                await appContext.loadTeams();
            }
        })();
    }, [appContext.teams])

    useEffect(() => {
        (async function loadEmployees() {
            if(!appContext.employees.length){
                await appContext.setEmployees();
            }
        })();
    }, [appContext.employees])

    // useEffect(() => {
    //     if(history.action === 'POP'){
    //         console.log("in here")
    //         setSelectEmployee(false)
    //         props.setCurrPage('team')
    //     }
    // })

    useEffect(() => {        
        console.log("================")
        // console.info({props})
        if(id && appContext.teams.length && appContext.employees){
            var teamSelected = appContext.teams.filter(team => {return team.id === id})[0]
            // setTeam(props.teamData)
            setTeam(teamSelected)
            const employeesResponse = appContext.employees;
            var teamEmployees = employeesResponse.filter(employee => {return employee.teamId === teamSelected.id})
    
            setEmployees(teamEmployees);
            setTeamSize(teamEmployees.length)
            const activePerk = teamEmployees.reduce((n, x) => {return n + (x.status === 'active')}, 0);
            const activeExpense = teamEmployees.reduce((n,x) => {
                return n + (x.expenseStatus === 'activateHR' || x.expenseStatus === 'activateEmployee')
            }, 0);
            setPerkCount(activePerk ? activePerk : 0);
            setExpenseCount(activeExpense ? activeExpense : 0);
            var date = new Date(teamSelected.createdAt);
            setCreated(date ? (date.getMonth()+1)+'/'+date.getDate()+'/'+date.getFullYear() : 'Not Available')
            // props.setClickTeamName(null)
        }
        
    }, [appContext.employees, appContext.teams, id]);

    const nextButtonClicked = (employeeId) => {
        // setSelectEmployee(true);
        // setSelectedEmployee(employee);
        // props.setCurrPage('employee')
        // history.push(`/programs/teams/id/employee`)
        history.push(`/programs/employees/${employeeId}`)
    }

    
    return(
        
        <div style={{width: '90vw'}}>
            {/* --- page starts from here --- */}
                {/* !(selectEmployee) ?  */}
                    <div id="employees-page" className="dashboard-page">
                        {appContext.loading && (<Dimmer active inverted>
                            <Loader inverted>Loading</Loader>
                        </Dimmer>) && selectEmployee === ''}

                        {team && employees ?
                            <div className="sub-page" id="team-management" style={{width: '90vw'}}>
                                <div className="ui segment" style={{backgroundColor: 'transparent', marginRight: 0, paddingRight: 0, width: '90vw'}}>
                                    <div style={{fontSize: 28, fontWeight: '900', letterSpacing: 1, fontStyle: 'SFProText-Bold',  paddingBottom: 10, marginTop: 5}}>Team Name: {team.name.charAt(0).toUpperCase() + team.name.slice(1)}</div>

                                    <div className="ui secondary menu" style={{display: 'flex', flex:1, flexDirection:'row', marginBottom: -10, paddingLeft: 15, marginRight: 15, fontStyle: 'SFProText-Regular'}}>
                                        <span style = {{display:'flex', fontSize: 18, flex:1.2, flexDirection:'row'}}>
                                            <span style = {{display:'flex', fontSize: 18, flex:0.7}}>Active Since:</span>
                                            <span style = {{display:'flex', fontSize: 18, flex:1.3, fontWeight:600}}>{created}</span>
                                        </span>
                                        <span style = {{display:'flex', fontSize: 18, flex:1.2}}>
                                            <span style = {{display:'flex', fontSize: 18, flex:0.6}}>Perk Budget:</span>
                                            <span style = {{display:'flex', fontSize: 18, flex:1.2}}>${team.budget}</span>
                                        </span>
                                        <span style = {{display:'flex', fontSize: 18, flex:1.4}}>
                                            <span style = {{display:'flex', fontSize: 18, flex:0.8}}>Expense Card Limit:</span>
                                            <span style = {{display:'flex', fontSize: 18, flex:1.2}}>${team.expenseLimit}</span>
                                        </span>
                                    </div>
                                    <div className="ui secondary  menu" style={{flex:1, flexDirection:'row', marginBottom: -10, paddingLeft: 15, marginRight: 15,  fontStyle: 'SFProText-Regular'}}>
                                        <span style = {{display:'flex', fontSize: 18, flex:1, flexDirection:'row'}}>
                                            <span style = {{display:'flex', fontSize: 18, flex:1.1}}>Accounts Active:</span>
                                            <span style = {{display:'flex', fontSize: 18, flex:1, flexDirection:'row', fontWeight:600}}>
                                                <span style = {{display:'flex', fontSize: 18, flex:1}}>Expenses:</span>
                                                <span style = {{display:'flex', fontSize: 18, flex:1, color:'green'}}>({expenseCount})</span>
                                            </span>
                                            <span style = {{display:'flex', fontSize: 18, flex:1, flexDirection:'row', fontWeight:600}}>
                                                <span style = {{display:'flex', fontSize: 18, flex:0.8}}>Perks:</span>
                                                <span style = {{display:'flex', fontSize: 18, flex:1, color:'green'}}>({perkCount})</span>
                                            </span>
                                        </span>
                                        <span style = {{display:'flex', fontSize: 18, flex:1.8, flexDirection:'row'}}>
                                            <span style = {{display:'flex', fontSize: 18, flex:1}}>Team Size:</span>
                                            <span style = {{display:'flex', fontSize: 18, flex:6.4}}>{teamSize}</span>
                                        </span>
                                    </div>
                                </div>
                                <div>
                                    {employees.length ? 
                                        <table className="teams-table" style={{marginRight: 0, paddingRight: 0, textAlign: 'center',width: '90vw'}}>
                                            <thead>
                                                <tr style={{fontStyle: 'SFProText-Regular', fontSize: 12}}>
                                                    <th>Employee Name</th>
                                                    <th>Perk Card Status</th>
                                                    <th>Expense Card Status</th>
                                                    <th />
                                                    <th />
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {employees.map(employee => <TeamDetailsTable key={employee.id} 
                                                                                        employee={employee} 
                                                                                        // setSelectEmployee={setSelectEmployee} 
                                                                                        // setSelectedEmployee={setSelectedEmployee} 
                                                                                        nextButtonClicked={nextButtonClicked} />)}
                                            </tbody>
                                        </table>
                                    :
                                        <div className="ui segment center aligned"><h5>There are no employees to be displayed.</h5></div>
                                    }
                                </div>
                                {/* <footer className="ui three column grid" style={{margin: 0, padding: 0}}>
                                            <div className="column"><h5>Total Budget: ${team.budget * employees.length}</h5></div>
                                            <div className="column"><h5>Total Expenses: ${team.expenseLimit * employees.filter(emp => {return emp.expenseStatus === 'activateEmployee'}).length}</h5></div>
                                            <div className="column"><h5>Total Employees: {employees.length}</h5></div>
                                        </footer> */}
                            </div>
                        : null }
                    </div>
                {/* :   <Switch>
                        <Route path={`/programs/teams/id/employee`} ><EmployeeDetails employee={selectedEmployee} />  </Route>
                    </Switch> */}

            {/* --- page ends here --- */}
        </div>
    )
}

// export default TeamDetails;